import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/ImportantConsumerInfoPage.css";

const DEFAULT_NEXT_PATH = "/summary-updates";

export default function ImportantConsumerInfoPage({
  nextPath = DEFAULT_NEXT_PATH,
}) {
  const navigate = useNavigate();
  const [acknowledged, setAcknowledged] = useState(false);

  const handleContinue = () => {
    if (!acknowledged) return;
    navigate(nextPath);
  };

  return (
    <div className="ic-page">
      <header className="ic-header">
        <div className="ic-headerInner">
          <div className="ic-titleBlock">
            <h1 className="ic-title">Informações importantes</h1>
            <p className="ic-subtitle">Leia com atenção antes de continuar.</p>
          </div>
        </div>
      </header>

      <main className="ic-main">
        <section className="ic-card" aria-labelledby="consumer-info-title">
          <div className="ic-cardHeader">
            <h2 id="consumer-info-title" className="ic-cardTitle">
              INFORMAÇÕES IMPORTANTES PARA O CONSUMIDOR
            </h2>
          </div>

          <div
            className="ic-content"
            role="region"
            aria-label="Conteúdo do termo"
          >
            <p>
              Este documento contém informações importantes sobre seu Novo
              Contrato de Prestação de Serviços proposto. Somos obrigados a lhe
              fornecer essas informações pela legislação inglesa. Este documento
              também contém informações sobre seu direito de cancelar o Novo
              Contrato de Prestação de Serviços e como você pode fazer isso.
              Certifique-se de que você entendeu este documento antes de assinar
              o Novo Contrato de Prestação de Serviços.
            </p>

            <ol>
              <li>
                O Regulamento de Contratos com o Consumidor (Informações,
                Cancelamento e Encargos Adicionais) de 2013 é uma lei inglesa
                que lhe dá certos direitos e proteções, inclusive o direito de
                cancelar seu Novo Contrato de Prestação de Serviços conosco.
                Esta página informa sobre seus direitos e proteções, bem como
                sobre como você pode usá-los. Esses direitos e proteções se
                aplicam a você, mesmo que você more no Brasil.
              </li>
              <li>
                Por "Novo Contrato de Prestação de Serviços", entendemos o
                Acordo Coletivo de Honorários de Êxito ("CCFA") e o Contrato de
                Gerenciamento de Litígio ("LMA") reapresentados. Em breve, você
                receberá o Novo Contrato de Prestação de Serviços juntamente com
                um resumo de seus termos em linguagem simples.
              </li>
              <li>
                Você tem o direito de cancelar o Novo Contrato de Prestação de
                Serviços dentro do "período de cancelamento", que é de 14 dias
                após o dia em que você fez o contrato (geralmente é o dia em que
                você o assina ou concorda eletronicamente com ele). A
                Notificação de seu Direito de Cancelamento está disponível aqui.
              </li>
              <li>
                O final da Notificação contém um pequeno formulário que pode ser
                usado para cancelar o Novo Contrato de Prestação de Serviços.
                Você pode preencher o formulário de cancelamento e enviá-lo para
                nós por correio ou e-mail ou entregá-lo em mãos. Você não
                precisa usar esse formulário. Se preferir, poderá entrar em
                contato conosco por qualquer meio razoável durante o período de
                cancelamento de 14 dias, informando-nos que deseja cancelar; por
                exemplo, enviando-nos um e-mail para contato@pogustgoodhead.com
              </li>
              <li>
                Se você cancelar, isso afetará somente a CCFA e a LMA revisadas,
                e você continuará vinculado ao CCFA e à LMA existentes. Se você
                quiser que paremos de atuar para você em sua ação por completo,
                você deverá rescindir seus contratos existentes. Se desejar
                fazer isso, entre em contato conosco e o orientaremos sobre as
                próximas etapas (incluindo as vantagens e desvantagens).
              </li>
              <li>
                Se você concordar com o Novo Contrato de Prestação de Serviços,
                você também nos instrui a continuar trabalhando imediatamente em
                sua ação, o que, na prática, significa que continuaremos
                trabalhando em sua ação durante o período de cancelamento. Isso
                significa que, se você cancelar o CCFA e o LMA revisados, você
                continuará responsável pelo pagamento de qualquer trabalho que
                tenhamos feito (o que, na prática, significaria que você
                continuaria vinculado ao CCFA e ao LMA existentes).
              </li>
              <li>
                Uma vez expirado o período de cancelamento, você terá o direito
                de rescindir o Novo Contrato de Prestação de Serviços a qualquer
                momento, sem nos dar um motivo. Esse direito de rescisão é
                explicado abaixo no parágrafo 8(g) deste aviso.
              </li>
            </ol>

            <h3>
              8. A lei inglesa determina que você tem direito às seguintes
              informações:
            </h3>
            <ol className="ic-alpha">
              <li>
                <strong>a. Nossa identidade e detalhes de contato</strong> —
                Somos a PGMBM Law Ltd (atuando como Pogust Goodhead), uma
                empresa privada limitada por ações. Estamos registrados na
                Inglaterra e no País de Gales em 70 Mark Lane, Londres EC3R 7NQ,
                Reino Unido (Registro Nº 06284764). Podemos ser contatados no
                endereço acima pelo e-mail contato@pogustgoodhead.com. Nossos
                agentes brasileiros (seus Advogados Colaboradores) também estão
                disponíveis através dos meios pelos quais você normalmente os
                contata.
              </li>
              <li>
                <strong>b. A principal característica do serviço</strong> —
                Pretendemos prestar serviços jurídicos em relação à sua ação e
                ao litígio como um todo.
              </li>
              <li>
                <strong>c. Acordos para pagamento</strong> — Geralmente somos
                pagos pela recuperação dos custos dos Réus e pela dedução de
                quaisquer taxas e despesas adicionais de sua indenização. Isso
                normalmente ocorrerá no final de sua ação. Se recuperarmos os
                custos dos Réus no meio de sua ação, temos o direito de
                mantê-los naquele momento. Em circunstâncias raras e
                improváveis, você poderá ter que pagar nossos honorários e
                despesas do seu próprio bolso e quando solicitado a fazê-lo
                (veja abaixo); por exemplo, se você fizer um acordo em seu
                processo ou participar de um arranjo de compensação no Brasil,
                poderemos, em determinadas circunstâncias limitadas, solicitar
                que você nos pague com esses valores.
              </li>
              <li>
                <strong>
                  d. Desempenho e o tempo que levaremos para realizar o serviço
                </strong>{" "}
                — Prestaremos serviços em tempo hábil pelo tempo necessário para
                o andamento de sua ação e do litígio como um todo.
              </li>
              <li>
                <strong>e. O preço total do serviço, incluindo impostos</strong>{" "}
                — A CCFA explica como somos pagos. O que se segue é o mais breve
                dos resumos e não é exaustivo. Em essência:
                <ol className="ic-roman">
                  <li>
                    Se você perder, geralmente não pagará nada (cláusula 16.2 do
                    CCFA). No entanto, teremos permissão para ficar com
                    quaisquer custos que os Réus tenham pago ou venham a pagar
                    (cláusula 16.3 do CCFA).
                  </li>
                  <li>
                    Se você ganhar, então, em geral, 70% dos seus danos serão
                    "delimitados" e pagos a você. Você será responsável por
                    todos os nossos honorários e despesas (mais uma taxa de
                    sucesso; cláusula 19 do CCFA) relacionados à sua própria
                    ação e ao litígio em geral (cláusulas 16.1 e 20 do CCFA),
                    mas somente faremos valer nosso direito de receber esses
                    valores recuperando os custos dos Réus e deduzindo até 30%
                    de sua indenização (cláusula 16.4 e cláusula 16.5 do CCFA).
                    As porcentagens indicadas acima dependerão do grupo de
                    Requerentes ao qual você pertence: As pessoas físicas terão
                    pelo menos 70% dos danos delimitados, enquanto os clientes
                    pertencentes às comunidades indígenas e quilombolas
                    receberão pelo menos 94% dos danos delimitados.
                  </li>
                  <li>
                    A recuperação de danos em seu pedido de indenização ou
                    arranjo de compensação brasileiro será considerada uma
                    vitória (cláusula 16.8 do CCFA).
                  </li>
                  <li>
                    Certos limites adicionais sobre os valores que podemos
                    cobrar podem significar que deduzimos menos de 30% de seus
                    danos (cláusula 16.5 e cláusula 18 do CCFA), mas, na
                    prática, não é provável que esses limites adicionais sejam
                    relevantes.
                  </li>
                  <li>
                    Pode haver circunstâncias em que você (pessoalmente) tenha
                    de pagar nossos honorários do seu próprio bolso
                    (possivelmente com uma taxa de sucesso, se você ganhar).
                    Isso incluiria: (a) quando você nos pedir para realizar um
                    trabalho que não esteja coberto pelo CCFA (como um trabalho
                    desnecessário para a sua reivindicação (cláusula 16.7 do
                    CCFA); ou (b) quando o CCFA for rescindido (cláusula 35 do
                    CCFA). Observe que podemos rescindir o CCFA se você não
                    cumprir a sua parte do contrato (conforme estabelecido na
                    cláusula 26 do CCFA).
                  </li>
                  <li>
                    No caso improvável de você (pessoalmente) ser obrigado a
                    pagar nossos honorários do seu próprio bolso, você deverá
                    pagar os honorários relativos à sua própria ação ("Custos
                    Individuais"), mais a sua parte dos custos relativos ao
                    litígio como um todo ("Custos Comuns"); isso incluirá nossas
                    despesas ("Desembolsos"). Para os custos individuais, há
                    determinados honorários fixos (Tabela 10 do CCFA); caso
                    contrário, nossos honorários serão baseados no trabalho que
                    realizamos por hora (Tabela 9 do CCFA).
                  </li>
                  <li>
                    Se você já estiver obrigado a nos pagar quaisquer valores de
                    acordo com qualquer contrato de retenção que tenha conosco,
                    você ainda será responsável por esses valores, mas eles
                    serão levados em consideração para que você não tenha que
                    pagar duas vezes (cláusula 10 do CCFA).
                  </li>
                  <li>
                    Para evitar dúvidas, como você está no Brasil, não prevemos
                    que você terá que pagar o Imposto sobre Valor Agregado
                    ("IVA") sobre nossos honorários ou despesas, mas, mesmo que
                    tenha que pagar, você ainda terá direito aos seus danos
                    "delimitados" se ganhar.
                  </li>
                </ol>
              </li>
              <li>
                <strong>
                  f. No caso de um contrato de duração indeterminada, os custos
                  totais por período de faturamento
                </strong>{" "}
                — Sua responsabilidade por nossos honorários e despesas está
                resumida acima. Como você pode ver, o valor pelo qual você é
                responsável, em geral, não é o valor que você realmente paga
                (pois limitamos nossos honorários para "delimitar" parte de seus
                danos). Além disso, não podemos dizer qual será o valor total de
                nossos honorários e despesas, pois isso dependerá do andamento
                da ação e da sua participação nos Custos Comuns. Os Honorários
                Individuais Fixos serão acumulados a uma taxa fixa, sendo £2.500
                para o trabalho realizado exclusivamente no seu caso até 24 de
                outubro de 2022 e £500 por ano depois disso (Tabela 10 do CCFA).
                Esses honorários cobrem todo o trabalho que realizamos
                relacionado apenas à sua ação (exceto qualquer trabalho
                relacionado ao pedido de jurisdição do Réu de 7 de agosto de
                2019).
              </li>
              <li>
                <strong>
                  g. Se o contrato for de duração indeterminada, as condições
                  para rescisão desse contrato
                </strong>{" "}
                — O cliente poderá rescindir o CCFA ou a LMA a qualquer momento
                por qualquer (ou nenhum) motivo; a rescisão de um também
                rescindirá o outro. Em caso de rescisão, o cliente poderá ser
                obrigado a pagar nossas Taxas Básicas e Desembolsos
                incondicionalmente e integralmente (ou seja, independentemente
                de ganhar ou perder e sem ser limitado de forma alguma pelos
                danos (cláusula 35 do CCFA)); isso incluirá seus Custos
                Individuais e sua parte dos Custos Comuns. Em geral, você só
                evitará ter que pagar esses valores se: (a) estivermos violando
                nossas obrigações; (b) você tiver nos notificado por escrito
                sobre essa violação; e (c) nossas falhas forem significativas e
                substanciais. Os detalhes estão definidos no CCFA na cláusula
                35. O direito de rescisão é separado do seu direito de
                cancelamento explicado acima.
              </li>
              <li>
                <strong>
                  h. A existência de códigos de conduta relevantes e como cópias
                  deles podem ser obtidas
                </strong>{" "}
                — Estamos autorizados a atuar como uma firma de advogados e
                somos regulamentados pela Solicitors Regulation Authority (SRA
                ID 512898). Uma cópia do Código de Conduta da SRA para
                Advogados, RELs e RFLs pode ser encontrada no site da SRA.
              </li>
              <li>
                <strong>i. Nossa política de tratamento de reclamações</strong>{" "}
                — Temos uma política de tratamento de reclamações. Você tem o
                direito de reclamar sobre nossos serviços ou nossas cobranças.
                As reclamações podem ser endereçadas ao Client Service Quality
                Manager de 70 Mark Lane, London EC3R 7NQ, Reino Unido ou podem
                ser enviadas para complaints@pogustgoodhead.com.
              </li>
              <li>
                <strong>j. Mecanismo extrajudicial</strong> — Se você fizer uma
                reclamação e não estiver satisfeito com o resultado, poderá
                reclamar com o Ombudsman Jurídico.
              </li>
              <li>
                <strong>
                  k. Custos associados ao uso de comunicação à distância
                </strong>{" "}
                — Nenhum.
              </li>
              <li>
                <strong>l. Comunicações eletrônicas</strong> — Ao fazer o CCFA e
                a LMA, você concorda com o uso de comunicações eletrônicas e que
                documentos possam ser fornecidos como PDF.
              </li>
            </ol>

            <h3>9. Obrigação profissional</h3>
            <ol className="ic-alpha">
              <li>
                <strong>a. Financiadores</strong> — Temos um acordo para
                reembolsar nossos financiadores, de nossos honorários; os
                detalhes são comercialmente sensíveis e confidenciais, mas
                confirmamos que o acordo está por escrito e que se refere apenas
                aos nossos honorários.
              </li>
              <li>
                <strong>b. Advogado Colaborador</strong> — Você pode ou não ter
                o benefício da assistência do Advogado Colaborador. Se for o
                caso, temos um acordo para dividir os honorários.
              </li>
              <li>
                <strong>c. Co-ordenadores</strong> — Também temos um acordo de
                partilha de honorários com os Co-ordenadores.
              </li>
            </ol>

            <p className="ic-footerNote">
              10. Para evitar dúvidas, as diversas taxas e pagamentos
              mencionados no parágrafo acima não são diretamente pagáveis por
              você e não terão impacto sobre a "delimitação" de seus danos.
            </p>
          </div>

          <div className="ic-links">
            <p className="ic-linksTitle">Documentos relacionados</p>

            <ul className="ic-linksList">
              <li>
                <a
                  href="https://assets.pogustgoodhead.com/documents/project_r/ClientCareLetter27012025.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Notificação Acerca do seu Direito de Cancelamento
                </a>
              </li>

              <li>
                <a
                  href="https://assets.pogustgoodhead.com/documents/project_r/ClientCareLetter27012025.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Carta do serviço de atendimento ao cliente
                </a>
              </li>
            </ul>
          </div>

          <div className="ic-ack">
            <label className="ic-checkbox">
              <input
                type="checkbox"
                checked={acknowledged}
                onChange={(e) => setAcknowledged(e.target.checked)}
              />
              <span>
                Li e entendi as informações importantes para o consumidor acima.
              </span>
            </label>

            <button
              type="button"
              className={`ic-continue ${acknowledged ? "isEnabled" : "isDisabled"}`}
              onClick={handleContinue}
              disabled={!acknowledged}
            >
              Continuar
            </button>
          </div>
        </section>
      </main>
    </div>
  );
}
